import React, { Component } from 'react';
import Slider from "components/FrontEnd/Header/Slider";

import app_screen_1 from "assets/img/app_screens_1.png";
import app_screen_2 from "assets/img/app_screens_2.png";
import app_screen_3 from "assets/img/app_screens_3.png";
import app_screen_4 from "assets/img/app_screens_4.png";
import app_screen_5 from "assets/img/app_screens_5.png";


import its_simple from "assets/img/its_simple.png";
import music_dirctor from "assets/img/music_dirctor.png";
import adjucator from "assets/img/adjucator.png";
// import video_banner from "assets/img/video_banner.jpg";
import about from "assets/img/about.png";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import video_banner_video from "assets/img/video_banner.png";

// import playBtn from "assets/img/playBtn.jpg";
import play_Btn from "assets/img/play-button.svg";


class Home extends Component{
  constructor(props){
    super(props);
    this.state = {
      playVideo : true,
      buttonProp : true,
      controlsProp : false
    };
    
    this.playVid = this.playVid.bind(this);
    this.onPauseFunction = this.onPauseFunction.bind(this);
    this.onPlayFunction = this.onPlayFunction.bind(this);
  }
  onPlayFunction(){
    //console.log('1');
    // let vid = document.getElementById("playVid");

    // vid.play();
    this.setState({buttonProp:false}, function(){
      this.setState({controlsProp:true});
    });
    this.state.playVideo = !this.state.playVideo

  }
  onPauseFunction(){
    //console.log('2');
    // let vid = document.getElementById("playVid");
    // vid.pause();
    this.setState({buttonProp:true}, function(){
      //this.setState({controlsProp:false});
    });
    this.state.playVideo = !this.state.playVideo
  }
  playVid(){
    //console.log('3');
    let vid = document.getElementById("playVid");
    if(this.state.buttonProp){
      vid.play();
      this.setState({buttonProp:false}, function(){
        this.setState({controlsProp:true});
      });
      this.state.playVideo = !this.state.playVideo
    }
    else{
      vid.pause();
      this.setState({buttonProp:true}, function(){
        //this.setState({controlsProp:false});
      });
      this.state.playVideo = !this.state.playVideo
    }
  }
 	render(){
    const { buttonProp,controlsProp } = this.state;
  	return(
    	<div>
        <Slider />
        <section className="section" id="php_developer">
          <div className="section_title">
            <h2>Music Adjudicator</h2>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="service_container text-center">
                  <img src={its_simple} alt="simpleImage"/>

                  <h3>It's simple</h3>

                  <p>MusicAdjudicator.com makes it easy for adjudicators to share their comments with each music director attending with their group at a competitive festival.</p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="service_container text-center">
                  <img src={music_dirctor} alt="musicDirectorImage" />

                  <h3>Music Directors</h3>

                  <p>Login to our free app with a unique username provided by your festival operator. Choose from a list of adjudicators who have provided comments about your group.</p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="service_container text-center">
                  <img src={adjucator} alt="adjucatorImage"/>

                  <h3>Adjudicators</h3>

                  <p>Using our free app, adjudicators login with a username, select from a list of music groups, and make their verbal comments to be privately heard by the music director.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="sec_line"></div>
        <section className="section section-frontEnd">
          <div className="section_title">
            <h2 className="mt-0">HOW IT WORKS</h2>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="video_container">
                  <video id="playVid" controls onPause={this.onPauseFunction} onPlay={this.onPlayFunction} width="740" height="478"  poster={video_banner_video}>
                    <source src="https://musicadjudicator.com/videos/music_adjudicator_demo.mp4" type="video/mp4" />
                  </video>
                  {
                    buttonProp && 
                    <img onClick={this.playVid} className="playBtn" height="83" src={play_Btn} />
                  }
                  { /*
                  <img src={video_banner} alt="videoBannerImage"/>
                  */}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section section-frontEnd" id="help">
          <div className="screen_imgs">
            <OwlCarousel
              className="owl-theme"
              loop
              margin={50}
              nav={false}
              dots={false}
              responsiveClass={true}
              autoWidth={true}
            >
              <div className="img item"><img src={app_screen_1} alt="app_screen_1" /></div>
              <div className="img item"><img src={app_screen_2} alt="app_screen_2" /></div>
              <div className="img item"><img src={app_screen_3} alt="app_screen_3" /></div>
              <div className="img item"><img src={app_screen_4} alt="app_screen_4" /></div>
              <div className="img item"><img src={app_screen_5} alt="app_screen_5" /></div>
            </OwlCarousel>
          </div>
        </section>
        <div className="sec_line"></div>
        <section className="section section-frontEnd">
          <div className="section_title">
            <img src={about} alt="aboutImage"/>
            <h2 className="mt-20">About Us</h2>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <p className="about_text">
                  MusicAdjudicators.com was developed by PhotoVision, Inc. We serve educators and music programs with our products offered by tour and festival operators. We capture and preserve the memories made on these trips to have for a lifetime of enjoyment.
                </p>
              </div>
            </div>
          </div>
        </section>
       <div className="sec_line"></div>
     	</div>
  	);
  }
}
export default Home;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Home.jsx